import Skeleton from '@mui/material/Skeleton';

import { North } from '@mui/icons-material';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import React from 'react';

function EditUserSkeleton() {
    return (
        <>
            <Container>
                <Skeleton
                    variant="circular"
                    sx={{
                        display: 'flex',
                        backgroundSize: '160px 160px',
                        height: '160px',
                        width: '160px',
                        margin: '0px auto',
                    }}
                />
                <North
                    style={{
                        alignSelf: 'center',
                        color: '#999999',
                        margin: '0 0 0 0',
                    }}
                />

                <Typography
                    color="grey"
                    margin="0 0 0 0"
                    style={{ color: '#999999' }}
                    variant="body2"
                    align="center"
                >
                    {"Don't they look good?"}
                </Typography>
            </Container>
            <br />
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: '24px',
                }}
            >
                <Skeleton
                    variant="rectangular"
                    sx={{
                        width: '100%',
                        margin: '5px 0px 30px',
                        color: 'grey',
                        height: '40px',
                    }}
                />
                <Skeleton
                    variant="rectangular"
                    sx={{
                        width: '100%',
                        margin: '5px 0px 30px',
                        color: 'grey',
                        height: '40px',
                    }}
                />
            </div>
            <Skeleton
                variant="rectangular"
                sx={{
                    width: '100%',
                    margin: '0px 0px 30px',
                    color: 'grey',
                    height: '40px',
                }}
            />
        </>
    );
}

export default EditUserSkeleton;
